'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _Defaults = require('conversations-schema/constants/Defaults');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _KeyCodes = require('UIComponents/constants/KeyCodes');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIExpandingTextArea = require('UIComponents/input/UIExpandingTextArea');

var _UIExpandingTextArea2 = _interopRequireDefault(_UIExpandingTextArea);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIFormControl = require('UIComponents/legacy/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageEditor = function (_Component) {
  _inherits(MessageEditor, _Component);

  function MessageEditor(props) {
    _classCallCheck(this, MessageEditor);

    var _this = _possibleConstructorReturn(this, (MessageEditor.__proto__ || Object.getPrototypeOf(MessageEditor)).call(this, props));

    _this.state = { value: '' };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handlePublish = _this.handlePublish.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(MessageEditor, [{
    key: 'getValue',
    value: function getValue() {
      var value = this.state.value;

      return value;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return this.getValue().length < _Defaults.DEFAULT_MAX_MESSAGE_LENGTH;
    }
  }, {
    key: 'canPublish',
    value: function canPublish() {
      var _props = this.props,
          disabled = _props.disabled,
          visiblyOffline = _props.visiblyOffline;


      return this.isValid() && !disabled && this.getValue() !== '' && !visiblyOffline;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var chatInputChanged = this.props.chatInputChanged;

      this.setState({ value: e.target.value });
      if (this.getValue() !== '') {
        chatInputChanged();
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (e.keyCode === _KeyCodes.ENTER && e.shiftKey === false) {
        this.handlePublish();
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    }
  }, {
    key: 'handlePublish',
    value: function handlePublish() {
      if (this.canPublish()) {
        this.props.publishMessage({
          text: this.getValue(),
          richText: '<div>' + this.getValue() + '</div>'
        });
        this.setState({ value: '' });
      }
    }
  }, {
    key: 'getSendButtonStyle',
    value: function getSendButtonStyle() {
      var _props$coloring = this.props.coloring,
          accentColor = _props$coloring.accentColor,
          useDefaultColor = _props$coloring.useDefaultColor;

      return !useDefaultColor ? { color: accentColor } : null;
    }
  }, {
    key: 'getValidationMessage',
    value: function getValidationMessage() {
      return this.isValid() ? '' : _I18n2.default.text('input.chatTextArea.validationMessage');
    }
  }, {
    key: 'renderTextInput',
    value: function renderTextInput() {
      var _props2 = this.props,
          disabled = _props2.disabled,
          showingHsBranding = _props2.showingHsBranding,
          visiblyOffline = _props2.visiblyOffline;
      var value = this.state.value;


      var isAdmin = this.props.currentRole === _RoleTypes2.default.REP;

      var className = (0, _reactUtils.classNames)({
        'showing-branding': showingHsBranding,
        'flex-column': isAdmin
      });

      return _react2.default.createElement(
        _UIBox2.default,
        { grow: 0.95 },
        _react2.default.createElement(
          _UIFormControl2.default,
          {
            className: className,
            validationMessage: this.getValidationMessage(),
            error: !this.isValid()
          },
          _react2.default.createElement(_UIExpandingTextArea2.default, {
            className: 'widget-textarea message-box',
            maxHeight: 100,
            placeholder: visiblyOffline ? _I18n2.default.text('input.chatTextArea.offlinePlaceholder') : _I18n2.default.text('input.chatTextArea.placeholder'),
            shrink: true,
            resize: false,
            use: isAdmin ? 'on-dark' : 'default',
            disabled: disabled || visiblyOffline,
            onChange: this.handleChange,
            onKeyDown: this.handleKeyDown,
            error: !this.isValid(),
            value: value
          })
        )
      );
    }
  }, {
    key: 'renderSendButton',
    value: function renderSendButton() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _UIButton2.default,
          {
            className: 'chat-send-button',
            use: this.props.currentRole !== _RoleTypes2.default.REP ? 'link' : 'primary',
            disabled: !this.canPublish(),
            onClick: this.handlePublish,
            style: this.props.currentRole !== _RoleTypes2.default.REP ? this.getSendButtonStyle() : null
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'buttons.send' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UIFlex2.default,
        { align: 'center', justify: 'between', wrap: 'nowrap' },
        this.renderTextInput(),
        this.renderSendButton()
      );
    }
  }]);

  return MessageEditor;
}(_react.Component);

MessageEditor.propTypes = {
  disabled: _react.PropTypes.bool.isRequired,
  publishMessage: _react.PropTypes.func.isRequired,
  chatInputChanged: _react.PropTypes.func.isRequired,
  currentRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
  coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
  showingHsBranding: _react.PropTypes.bool,
  visiblyOffline: _react.PropTypes.bool.isRequired
};

exports.default = MessageEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/chat/MessageEditor.js
// module id = 275
// module chunks = 0 1